(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('CodePaymentsService', CodePaymentsService);

    CodePaymentsService.$inject = ['$http', '$q'];

    function CodePaymentsService($http, $q) {

        var requestUrl = 'api/code-payment';

        var service = {
            getAvailableCodes: getAvailableCodes,
        };
        return service;

        function getAvailableCodes() {
            return $http.get(requestUrl + '/availableCodes').then(
                function (response) {
                    return response.data;
                },
                function (errResponse) {
                    return $q.reject(errResponse);
                });
        }

    }
})();
